import 'whatwg-fetch';
import $ from 'jquery';

const serverUrl = "http://pluvid.com/proxy2/index.php?http://saigneurs.forumactif.org/";
const proxy = "http://pluvid.com/proxy2/index.php?";
const proxy2 = "http://pluvid.com:80/proxy2/index.php?";
const rechUrl = "http://pluvid.com/proxy2/index.php?http://saigneurs.forumactif.org/f23-tables-cherchant-des-joueurs";

var months = {
	"Jan": 0,
	"Fév": 1,
	"Mar": 2,
	"Avr": 3,
	"Mai": 4,
	"Juin": 5,
	"Juil": 6,
	"Ao�": 7,
	"Sep": 8,
	"Oct": 9,
	"Nov": 10,
	"Dec": 11
}

Date.prototype.yyyymmdd = function() {
  var mm = this.getMonth() + 1; // getMonth() is zero-based
  var dd = this.getDate();

  return [this.getFullYear(),
          (mm>9 ? '' : '0') + mm,
          (dd>9 ? '' : '0') + dd
         ].join('');
};

Date.isLeapYear = function (year) { 
    return (((year % 4 === 0) && (year % 100 !== 0)) || (year % 400 === 0)); 
};

Date.getDaysInMonth = function (year, month) {
    return [31, (Date.isLeapYear(year) ? 29 : 28), 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month];
};

Date.prototype.isLeapYear = function () { 
    return Date.isLeapYear(this.getFullYear()); 
};

Date.prototype.getDaysInMonth = function () { 
    return Date.getDaysInMonth(this.getFullYear(), this.getMonth());
};

Date.prototype.addMonths = function (value) {
    var n = this.getDate();
    this.setDate(1);
    this.setMonth(this.getMonth() + value);
    this.setDate(Math.min(n, this.getDaysInMonth()));
    return this;
};

String.prototype.replaceAll = function(search, replacement) {
    var target = this;
    return target.replace(new RegExp(search, 'g'), replacement);
};

var escapeRegExp;

(function () {

  var specials = [
        // order matters for these
          "-"
        , "["
        , "]"
        // order doesn't matter for any of these
        , "/"
        , "{"
        , "}"
        , "("
        , ")"
        , "*"
        , "+"
        , "?"
        , "."
        , "\\"
        , "^"
        , "$"
        , "|"
      ]
    , regex = RegExp('[' + specials.join('\\') + ']', 'g')
    ;

  escapeRegExp = function (str) {
    return str.replace(regex, "\\$&");
  };

}());

class AjaxCalls {
	
	getRequest(url) {
		var init = {
		  method: "GET",
		  cache: "no-cache"
		}; 
		var request = new Request(url, init);
		return request;
	}
	
	getText(url) {
		return fetch(url)
		.then(function(response) {
			var out = response.text();
			return out;
		})
		.catch(function(error) {
			console.log(error);
		});
	}
	
	parseDate(date) {		
		var splits = date.split(" ");
		var day = splits[1];
		var month = months[splits[2]];
		var year = splits[3];
		var d = new Date();
		d.setDate(day);
		d.setMonth(month);
		d.setYear(year);
		return d;		
	}
	
	getUpcomingGame(url) {
		var request = this.getRequest(proxy + url);
		var obj = this;
		return this.getText(request).then(function(html) {
			var page = $.parseHTML(html);
			var el = $(".postbody div", page).first()[0];
			var el2 = $(".post-content", page).first()[0];
			if (typeof el == 'undefined')
				el = el2;
			return el.innerHTML.replaceAll("�", "?").replace(/(\<br\>)+/g, "<br />");
		});
	}
	
	getUpcomingGames() {
		var d = new Date();
		var day = d.getDate();
		var obj = this;
		var request = this.getRequest(serverUrl + "calendar?start=" + d.yyyymmdd());
		return this.getText(request).then(function(html) {
			var page = $.parseHTML(html);
			var dates = [];
			$("td table tbody tr td .genmed a", page).each(function(i, el) {
				var parsedDate = obj.parseDate(el.text);
				if (! isNaN(parsedDate.getTime()) && parsedDate.getTime() >= d.getTime())
					dates.push({date: parsedDate, url: el.href});
			});
			return dates;
		}).then(function(dates) {
			if (dates.length < 7) {
				d.addMonths(1);
				d.setDate(1);
				var request2 = obj.getRequest(serverUrl + "calendar?start=" + d.yyyymmdd());
				return obj.getText(request2).then(function(html) {
					var page = $.parseHTML(html);					
					$("td table tbody tr td .genmed a", page).each(function(i, el) {
						var parsedDate = obj.parseDate(el.text);
						
						if (! isNaN(parsedDate.getTime()) && parsedDate.getTime() >= d.getTime())
							dates.push({date: parsedDate, url: el.href});						
					});
					return dates;
				});
					
			} else {
				return dates;
			}
		});
	}
	
	parseGameType(title) {
		var lower = title.toLowerCase();
		if (lower.includes("acceuil") || lower.includes("accueil"))
			return "ACCUEIL";
		if (lower.includes("full"))
			return "FULL";
		if (lower.includes("brussels games festival") || lower.includes("event") || lower.includes("convention"))
			return "EVENT";		
		return "FULL";
	}
	
	cleanTitle(title) {
		return title.replace(/\[.*\]/g, "").replace(/\(?\d+\/\d+\/\d+\)?|\(?\d+\/\d+\)?|\(?\d+\.\d+\.\d+\)?|\(?\d+\.\d+\)?/g, "").trim();
	}
	
	getUpcomingGamesFromUrl(url) {
		var request = this.getRequest(proxy + url);
		var obj = this;
		return this.getText(request).then(function(html) {
			var page = $.parseHTML(html);
			var games = [];
			$(".topic-title a", page).each(function(i, el) {
				var title = el.text;
				var url = el.href;
				var accueil = title.toLowerCase().includes("accueil") || title.toLowerCase().includes("acceuil");
				var type = obj.parseGameType(title);
				title = obj.cleanTitle(title);
				games.push({type: type, accueil: accueil, title: title, url: url.replaceAll(escapeRegExp(proxy), "").replaceAll(escapeRegExp(proxy2), "")});
			})
			return games;
		});
	}
	
	getNewGames() {
		var request = this.getRequest(rechUrl);
		var obj = this;
		return this.getText(request).then(function(html) {	
			var page = $.parseHTML(html);
			var games = [];
			$(".forumline tbody tr", page).each(function (i, el) {
				var inner = el.innerHTML;
				if (! inner.includes("http://pluvid.com:80/proxy2/index.php?http://i71.servimg.com/u/f71/11/11/80/24/infono10.png") && ! inner.includes("http://pluvid.com:80/proxy2/index.php?http://i71.servimg.com/u/f71/11/11/80/24/postit10.png") && inner.includes("topictitle")) {
					var title = $("a.topictitle", el).first()[0].text;
					if (!(title.toLowerCase().includes("rech") || title.toLowerCase().includes("acceuil") || title.toLowerCase().includes("accueil")))
						return;
					var url = $("a.topictitle", el).first()[0].href;
					url = url.replaceAll(escapeRegExp(proxy), "").replaceAll(escapeRegExp(proxy2), "");
					var user = $(".name", el).first()[0].outerText;
					var game = {title: title.replaceAll("�", "?"), url: url, user: user.replaceAll("�", "?"), accueil: title.toLowerCase().includes("accueil") || title.toLowerCase().includes("acceuil")};
					if (! (title.includes("TERMINE") || title.includes("Sujet disparu")))
						games.push(game);
				}
			});
			$(".forum-section-wrap", page).each(function (i, el) {
				var inner = el.innerHTML;
				if (! (typeof inner === "undefined") && ! inner.toLowerCase().includes("info") && (inner.toLowerCase().includes("rech") || inner.toLowerCase().includes("acceuil") || inner.toLowerCase().includes("accueil"))) {
					var titleElement = $(".forum-content h3", el);
					var title = $(".forum-content h3", el)[0].textContent;
					if (!(title.toLowerCase().includes("rech") || title.toLowerCase().includes("acceuil") || title.toLowerCase().includes("accueil")))
						return;
					var url = $("a", el).first()[0].href;
					var user = "";
					var game = {title: title.replaceAll("�", "?"), url: url, user: user.replaceAll("�", "?"), accueil: title.toLowerCase().includes("accueil") || title.toLowerCase().includes("acceuil")};
					url = url.replaceAll(escapeRegExp(proxy), "").replaceAll(escapeRegExp(proxy2), "");
					if (! (title.includes("TERMINE") || title.includes("Sujet disparu")))
						games.push(game);
				}																													
			});
			return games;
		});
	}
	
}

var Ajax = new AjaxCalls();

export { Ajax };


// WEBPACK FOOTER //
// ./src/ajax/Ajax.js